// TEACUP (§13.4): B♭ major, 133.3 BPM, jazzy swing (8th-note swing 0.28). Walking upright bass
// with chromatic approach tones, Charleston EP comping in rootless voicings, a muted-trumpet lead,
// feathered kick, brush taps on 2 and 4 and a spang-a-lang ride. A: I–VI–ii–V and iii–VI–ii–V;
// B: IV–#iv°7–I then the secondary-dominant turnaround.
import type { SongDef } from '../songTypes';

export const TEACUP: SongDef = {
  id: 'teacup',
  rootMidi: 58,
  scale: 'major',
  swing: 0.28,
  swingUnit: 8,
  bars: 16,
  chords: [
    'Imaj7', 'vi7', 'ii7', 'V7', 'iii7', 'V7/ii', 'ii7', 'V7',
    'IVmaj7', '#ivdim7', 'Imaj7', 'V7/ii', 'ii7', 'V7', 'Imaj7', 'V7',
  ],
  drums: { kick: 'o...o...o...o...', snare: '....x.....o.x...', hat: 'x...x.x.x...x.x.', perc: '....x.......x...' },
  drumsB: { kick: 'o...o...o...o...', snare: '....x.o.....x.o.', hat: 'x...x.x.x...x.x.', perc: '....x.......x...' },
  fill: { kick: 'o.......x.....x.', snare: '....x.o.x.o.x.X.', hat: 'x...x.x.x.......', perc: '................' },
  pickup: { kick: '........x.....x.', snare: '....o.o.x.o.x.X.', hat: 'x...x.x.x...x.x.' },
  bass: [
    'Bb1 - - - D2 - - - F2 - - - F#2 - - -',
    'G2 - - - F2 - - - D2 - - - Db2 - - -',
    'C2 - - - Eb2 - - - G2 - - - E2 - - -',
    'F2 - - - A2 - - - C3 - - - Eb2 - - -',
    'D2 - - - F2 - - - A2 - - - Ab2 - - -',
    'G2 - - - B1 - - - D2 - - - Db2 - - -',
    'C2 - - - Eb2 - - - G2 - - - Gb2 - - -',
    'F2 - - - Eb2 - - - C2 - - - D2 - - -',
    'Eb2 - - - G2 - - - Bb2 - - - Eb2 - - -',
    'E2 - - - G2 - - - Bb2 - - - Gb2 - - -',
    'F2 - - - D2 - - - Bb1 - - - A1 - - -',
    'G1 - - - B1 - - - D2 - - - Db2 - - -',
    'C2 - - - D2 - - - Eb2 - - - E2 - - -',
    'F2 - - - Eb2 - - - C2 - - - A1 - - -',
    'Bb1 - - - D2 - - - F2 - - - E2 - - -',
    'F2 - - - C2 - - - Eb2 - - - A1 - - -',
  ],
  lead: [
    '. . F4 - Bb4 - D5 - F5 - - - - - D5 -',
    'D5 - - - Bb4 - G4 - F4 - - - . . . .',
    '. . Eb5 - G5 - - - F5 - Eb5 - C5 - - -',
    'A4 - - - . . C5 - Eb5 - - - D5 - C5 -',
    'D5 - - - F5 - - - A5 - - - - - G5 -',
    'F5 - - - D5 - B4 - - - G4 - - - . .',
    '. . Bb4 - C5 - Eb5 - G5 - - - F5 - Eb5 -',
    'D5 - - - C5 - - - A4 - - - . . . .',
    'G4 - Bb4 - D5 - - - . . Eb5 - D5 - Bb4 -',
    'Db5 - - - Bb4 - - - G4 - - - E4 - - -',
    'F4 - - - . . A4 - Bb4 - D5 - F5 - - -',
    'F5 - - - D5 - - - B4 - - - . . G4 -',
    'Eb5 - - - D5 - C5 - Bb4 - - - G4 - - -',
    'A4 - C5 - Eb5 - - - . . F5 - Eb5 - C5 -',
    'D5 - - - - - - - . . . . . . . .',
    '. . . . A4 - C5 - Eb5 - - - D5 - C5 -',
  ],
  arp: '. . . . . . 10 . . . . . 9 . . .',
  comp: 'X-....x-........',
  compB: 'X-......x-....o.',
  voicing: 'rootless',
  chordRange: [53, 72],
  instruments: { bass: 'upright', chords: 'ep', lead: 'mutedTrumpet', arp: 'bell', perc: 'hatPedal' },
  kit: { kick: 'kickSoft', snare: 'brushTap', hat: 'ride', crash: 'crash' },
  stabs: 'X.....x.........',
  mix: { kick: -4, hat: -3, perc: -6, arp: -8, lead: -2 },
};
